import { useCallback, useState } from 'react';
import tw from 'twin.macro';
import { useTranslation } from 'react-i18next';

import { Button } from '@components/Button';
import { CopyIcon } from '@icons/CopyIcon';
import { CheckMarkIcon } from '@icons/CheckMarkIcon';
import { stripHtmlAndPreserveNewlines } from '@utils/typographyUtils';
import { useInsightsContext } from '@insights_module/context/InsightsContext';
import {
  PROMOTION_VIEW_ITEMS,
  useEpisodeDetailsContext,
} from '@insights_module/context/EpisodeDetailsContext';
import { useEpisodeDetailsData } from '@insights_module/hooks/useEpisodeDetailsData';

const CopyButton = tw(
  Button.Primary
)`flex justify-center items-center min-h-[40px] px-[14px] disabled:bg-accent-muted disabled:cursor-not-allowed bg-accent-2 text-text-and-icon-invert border-none`;
const IconWrapper = tw.div`min-w-[16px] min-h-[16px]`;

export const CopyGeneratedContentButton = () => {
  const { t } = useTranslation();
  const { selectedEpisode } = useInsightsContext();
  const { activeView } = useEpisodeDetailsContext();
  const { selectedPromotionItem } = useEpisodeDetailsData();
  const [isActionClicked, setIsActionClicked] = useState(false);

  const handleActionClick = useCallback(() => {
    if (navigator && navigator.clipboard && selectedPromotionItem && selectedPromotionItem.value) {
      setIsActionClicked(true);
      setTimeout(() => setIsActionClicked(false), 1000);
      const formattedContent = stripHtmlAndPreserveNewlines(selectedPromotionItem.value);
      navigator.clipboard.writeText(formattedContent);
    }
  }, [selectedPromotionItem, selectedEpisode, activeView]);

  if (!PROMOTION_VIEW_ITEMS.includes(activeView)) return null;

  return (
    <CopyButton onClick={handleActionClick} disabled={!selectedPromotionItem?.value}>
      <IconWrapper>
        {isActionClicked ? (
          <CheckMarkIcon tw='stroke-text-and-icon-invert' />
        ) : (
          <CopyIcon tw='stroke-text-and-icon-invert' />
        )}
      </IconWrapper>
      {t('common.copy_to_clipboard')}
    </CopyButton>
  );
};
